import type { GridRenderHeaderFilterProps } from "@mui/x-data-grid-premium";
import type { SelectProps } from "src/components/SelectV2/SelectV2.types.ts";
import { DataGridInfiniteSelectHeaderFilterImpl } from "src/components/DataGrid/DataGridInfiniteSelectHeaderFilterImpl.tsx";

export const DataGridInfiniteSelectHeaderFilter = (
  props: GridRenderHeaderFilterProps &
    Pick<SelectProps<string>, "placeholder" | "allowClearValue">,
) => {
  // this wrapper exists only to fix hot reloading in this component
  return <DataGridInfiniteSelectHeaderFilterImpl {...props} />;
};
